<template>
  <div class="workList">
    <div class="header">
      <div class="container">
        <img class="logo" src="/img/ghltjLogo.png" alt="">
        <template v-if="gIsLogin()">
          <router-link class="nav" to="/personal_info">完善信息</router-link>
          <span class="nav" @click="logOut">退出登录</span>
        </template>
        <template v-else>
          <router-link class="nav" to="/login?fromUrl=/ddf_vote_list">登录</router-link>
          <router-link class="nav" to="/register?fromUrl=/ddf_vote_list">注册</router-link>
        </template>  
      </div>
      
    </div>
    <div class="container">
      <p class="voteTitle">第十六届（2020）光华龙腾奖公众投票</p>
      <p class="type">参评类型</p>
      <div class="prizeList">
        <div v-for="a in prizeList" :key="a.id" >
          <span class="typeItem" 
            :class="{'typeItemActive': prizeId==a.id}" 
            @click="changeType(a.id)">{{a.shortName}}</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <Row :gutter="30">
          <Col :lg="9" :md="9" :sm="24" :xs="24">
            <p>联系我们</p>
            <p>光华龙腾奖办公室</p>
            <p>地址：北京市大兴区金苑路26号院3号楼三层</p>
            <p>电话：15810007797</p>
            <p>传真：010-83681552</p>
            <p>邮箱：601@ddfddf.org</p>
            <p>
              <img class="code" src="/img/ghltjCode.jpg" alt="">
            </p>
          </Col>
          <Col :lg="15" :md="15" :sm="24" :xs="24">
            <p>组织机构</p>
            <p>主办：北京光华设计发展基金会</p>
            <p>战略合作媒体：新华社主管《中国名牌》杂志</p>
            <p>合作单位：中国创新设计产业战略联盟、工业和信息化部工业文化发展中心、中国机械工程学会、中国建筑装饰协会、中国勘察设计协会、中国室内装饰协会、中国工业设计协会、中国流行色协会、中国服装设计师协会、全国工商联家具装饰业商会、北京设计学会、广东省工业设计协会、浙江省工业设计协会、上海工业设计协会、深圳市工业设计协会、深圳市工业设计产业协会、清华大学美术学院、中央美术学院、浙江大学、中国美术学院、湖南大学等</p>
            <p>专业媒体：《设计》杂志、中国工业设计报、《视觉中国》、《视觉同盟》、《创意世界》、时机科技等</p>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "@/api/ddfVote";
export default {
  data() {
    return {
      prizeId: null,
      prizeList: []
    };
  },
  mounted() {
    document.title = "公众投票 - 光华龙腾奖（2020）中国设计贡献奖暨光华龙腾奖（2020）"
    this.getPrizeList();
  },
  computed: {
  },
  methods: {
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.go(0);
    },
    // 获取参评类型
    getPrizeList() {
      this.loading = true;
      Service.getDDFPrize()
        .then(res => {
          if (res.errorNo == 0) {
            this.prizeList = res.data;
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 切换参赛类型
    changeType(id) {
      this.prizeId = id;
      // this.$router.push("/ddf_vote?p_type=" + id);
      this.$router.push("/ddf_vote_new?p_type=" + id);
    }
  }
};
</script>

<style lang="scss" scoped>
.workList {
  min-height: 100%;
  padding-top: 60px;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    // background: url(/img/navBg.jpg) no-repeat center #ffffff;
    background: rgba(0, 0, 0, 0.85);
    background-size: cover;
    text-align: right;
    z-index: 999;

    .logo {
      float: left;
      width: 70px;
      margin-top: 4px;
    }

    .nav {
      line-height: 50px;
      color: #fff;
      padding: 0 10px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .type {
    padding: 10px 0;
  }
  .typeItem {
    display: inline-block;
    padding: 2px 10px 3px;
    margin: 0 10px 10px 0;
    border: 1px solid #7f7f7f;
    border-radius: 5px;
    cursor: pointer;
  }
  .typeItemActive {
    cursor: default;
    background: linear-gradient(to right, #5de2c6, #46a2e1);
    color: #fff;
    border-color: #5de2c6;
  }
  .voteTitle {
    text-align: center;
    padding: 20px 15px;
    font-size: 20px;
    color: #D30830;
  }
  .btnWrap {
    padding: 30px 0;
    text-align: center;
  }
  .jishu{
    text-align: center;
    padding: 0 0 20px;
    font-size: 12px;
  }
  .prizeList{
    padding: 0 0 20px;
  }
  .footer {
    padding: 50px 0;
    line-height: 1.8em;
    background: #ac1a2c;
    color: #f2f2f2;

    .code {
      width: 50%;
      max-width: 110px;
      padding: 10px 0;
    }
  }
}
</style>
